import { Popover } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { IoMdAddCircleOutline } from 'react-icons/io';
import { Checkbox } from '../Checkbox';
import { PopoverContainer } from '../styles';

export type DataButtonPopover = {
  id: string | number;
  name: string;
};

type Props = {
  title: string;
  data: DataButtonPopover[];
  onItemsChecked: (items: DataButtonPopover[]) => void;
  defaultValue: DataButtonPopover;
};

export const ButtonPopover = ({ title, data, onItemsChecked, defaultValue }: Props) => {
  const [markAll, setMarkAll] = useState(false);
  const [showPopover, setShowPopover] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);
  const popoverRef = useRef<HTMLDivElement | null>(null);
  const [itemsChecked, setItemsChecked] = useState<DataButtonPopover[]>([]);

  const handleMarkAll = () => {
    setMarkAll(true);
    setItemsChecked(data);
    onItemsChecked(data);
  };
  const handleDeselectAll = () => {
    setMarkAll(false);
    setItemsChecked([]);
    onItemsChecked([]);
  };

  useEffect(() => {
    setItemsChecked(() => [
      {
        id: defaultValue.id,
        name: defaultValue.name,
      },
    ]);
  }, [defaultValue.id, defaultValue.name]);

  useEffect(() => {
    const handleClosePopoverOnScroll = (event: Event) => {
      const uiEvent = event as UIEvent;
      if (popoverRef.current && popoverRef.current.contains(uiEvent.target as Node)) {
        return;
      }
      setShowPopover(false);
    };

    if (showPopover) {
      window.addEventListener('scroll', handleClosePopoverOnScroll, { capture: true });
    }

    return () => {
      window.removeEventListener('scroll', handleClosePopoverOnScroll, { capture: true });
    };
  }, [showPopover]);
  return (
    <>
      <button
        type="button"
        ref={anchorRef}
        onClick={() => {
          setShowPopover(true);
        }}>
        {title}
        <IoMdAddCircleOutline />
      </button>
      <Popover
        style={{ height: '190px' }}
        open={showPopover}
        onClose={() => setShowPopover(false)}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        disableScrollLock
        ref={popoverRef}>
        <PopoverContainer>
          <div>
            <div className="mark-unmark">
              <button type="button" onClick={handleMarkAll}>
                Marcar todos
              </button>
              <button type="button" onClick={handleDeselectAll} style={{ marginLeft: '5px' }}>
                Desmarcar todos
              </button>
            </div>
            {data.map((item) => (
              <Checkbox
                key={item?.id}
                item={item}
                isChecked={itemsChecked.some((i) => i.id === item?.id) || markAll}
                onChecked={(checked) => {
                  let newItems = [...itemsChecked];

                  if (checked) {
                    newItems.push(item);
                  } else {
                    newItems = newItems.filter((i) => i.id !== item.id);
                    setMarkAll(false);
                  }
                  onItemsChecked(newItems);
                  setItemsChecked([...newItems]);
                }}
              />
            ))}
          </div>
        </PopoverContainer>
      </Popover>
    </>
  );
};
